export const ROUTE_CYCLES_TYPES = {
  LOAD_ROUTE_CYCLES: "LOAD_ROUTE_CYCLES",
  SET_ROUTE_CYCLES: "SET_ROUTE_CYCLES",
  CLEAR_ROUTE_CYCLES: "CLEAR_ROUTE_CYCLES",
  // new facility
  NEW_ROUTE_CYCLE: "NEW_ROUTE_CYCLE",
  SEND_NEW_ROUTE_CYCLE: "SEND_NEW_ROUTE_CYCLE",
  SET_NEW_ROUTE_CYCLE: "SET_NEW_ROUTE_CYCLE",

  EDIT_ROUTE_CYCLE: "EDIT_ROUTE_CYCLE",
  SET_EDITED_ROUTE_CYCLE: "SET_EDITED_ROUTE_CYCLE",
  SET_EDITED_ROUTE: "SET_EDITED_ROUTE",
  DELETE_ROUTE_CYCLE: "DELETE_ROUTE_CYCLE",
  HANDLE_ROUTE_CYCLES_INPUTS: "HANDLE_ROUTE_CYCLES_INPUTS",
};
